<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'impersonate',
    subject: 'User',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-user-follow-line',
  color: 'error',
  title: 'Impersonate (Login Sebagai User Lain)',
  description: 'Melihat aplikasi dari sudut pandang user lain untuk keperluan dukungan teknis.',
  purpose: 'Panduan memakai fitur Impersonate untuk membantu troubleshooting akun pengguna lain — tanpa perlu tahu passwordnya.',
  concept: [
    {
      icon: 'ri-eye-line',
      title: 'Anda Benar-Benar Melihat Apa yang Mereka Lihat',
      text: 'Selama sesi impersonate berjalan, tampilan Anda persis sama seperti user yang Anda tiru — termasuk menu dan akses yang tersedia untuknya, BUKAN akses super-admin Anda sendiri.',
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Semua Tindakan Tetap Tercatat Atas Nama Anda',
      text: 'Meski tampilan berubah jadi milik user lain, Audit Trail tetap mencatat bahwa AndalAH (admin asli) yang melakukan tindakan itu, dengan penanda tambahan "sedang impersonate siapa" — jejaknya bisa ditelusuri dua arah.',
    },
  ],
  steps: [
    { title: 'Buka menu Administrasi → Users', detail: 'Cari user yang ingin Anda bantu.' },
    { title: 'Klik tombol "Impersonate" pada baris user tersebut', detail: 'Tombol ini tidak muncul untuk user dengan role super-admin.' },
    { title: 'Tampilan Anda otomatis berubah menjadi sudut pandang user tersebut', detail: 'Ada banner khusus di bagian atas layar yang menandakan Anda sedang impersonate.' },
    { title: 'Klik "Berhenti Impersonate" pada banner untuk kembali ke akun Anda', detail: 'Sesi Anda sendiri tidak terganggu selama proses ini.' },
  ],
  warning: 'Fitur ini hanya untuk super-admin, dan tidak bisa dipakai untuk impersonate sesama super-admin — mencegah penyalahgunaan akses tertinggi.',
  tips: [
    'Pakai fitur ini saat user melapor "menu saya tidak muncul" — Anda bisa langsung lihat persis apa yang mereka lihat tanpa perlu menebak-nebak.',
  ],
  faq: [
    { q: 'Apakah user yang saya impersonate tahu kalau sesinya sedang diambil alih?', a: 'Tidak ada notifikasi otomatis ke user tersebut — tapi seluruh aktivitas tercatat di Audit Log dan bisa ditelusuri kapan pun.' },
    { q: 'Apakah logout saat impersonate akan me-logout akun asli saya juga?', a: 'Tidak — logout saat sedang impersonate hanya mengakhiri sesi impersonate itu, akun asli Anda tetap aman.' },
  ],
  related: [
    { title: 'Audit Log', sub: 'Menelusuri jejak aktivitas impersonate', icon: 'ri-file-search-line', color: 'error', to: { name: 'help-administrasi-audit-log' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
